import User, { GetUserSettings } from "app/models/user"
import { Action, Types } from "./currentUser.actions"

export type CurrentUserState = {
  data: User | undefined
  userSettingsData: GetUserSettings
  errors: object
  loading: boolean
  userSettingsLoading: boolean
  dispatched: boolean
}

const initialState: CurrentUserState = {
  data: undefined,
  userSettingsData: { hide_weekend: false, hide_time: false, hide_warnings: false, horizontal_scale: 100 },
  errors: {},
  loading: false,
  userSettingsLoading: false,
  dispatched: false,
}

export default (state = initialState, action: Action): CurrentUserState => {
  switch (action.type) {
    case Types.GET_CURRENT_USER:
      return {
        ...state,
        loading: true,
        dispatched: false,
      }

    case Types.GET_CURRENT_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload.data,
        dispatched: true,
      }

    case Types.GET_CURRENT_USER_FAIL:
      return {
        ...state,
        errors: action.payload.errors,
        loading: false,
        dispatched: true,
      }

    case Types.PUT_USER_SETTINGS:
      return {
        ...state,
        userSettingsLoading: true,
      }

    case Types.PUT_USER_SETTINGS_SUCCESS:
      return {
        ...state,
        userSettingsData: action.payload.data,
        userSettingsLoading: false,
      }

    case Types.PUT_USER_SETTINGS_FAIL:
      return {
        ...state,
        errors: action.payload.errors,
        userSettingsLoading: false,
      }

    default:
      return state
  }
}
